import { Component } from '@angular/core';

@Component({
  selector: 'app-campus-landingpage',
  templateUrl: './campus-landingpage.component.html',
  styleUrls: ['./campus-landingpage.component.scss']
})
export class CampusLandingpageComponent {

}
